import React from 'react';
import { Accordion, TableContainer } from '../../../ui/components';
import OperationCenterErrorCard, {
  ErrorType,
} from '../../../ui/components/OperationCenterErrorCard/OperationCenterErrorCard';
import { ControlIconType } from '../../../ui/components/Accordion/Accordion';
import { getAuditHistoryLog } from './auditLogConfig';

interface AuditLogEntry {
  createdDate: string;
  createdBy: string;
  action: string;
}

interface Props {
  auditHistoryLog: AuditLogEntry[];
  displayAuditEmpty: boolean;
}

const AuditHistoryAccordion: React.FC<Props> = ({ auditHistoryLog, displayAuditEmpty }) => {
  const sortedAuditHistoryLog = [...auditHistoryLog].sort(
    (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime(),
  );
  return (
    <Accordion id="historyAccordion" key="historyAccordion" iconType={ControlIconType.CHEVRON} title="History Log">
      <div>
        {displayAuditEmpty ? (
          <OperationCenterErrorCard errorType={ErrorType.NO_RECORD} />
        ) : (
          <TableContainer dataSource={sortedAuditHistoryLog} getColumns={getAuditHistoryLog} />
        )}
      </div>
    </Accordion>
  );
};

export default AuditHistoryAccordion;
